import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { POLICY_TEMPLATE_TYPES } from '../../../../../context/PolicyTemplatesContext'
import ModalBody from './ModalBody'
import ModalFooter from './ModalFooter'
import ModalHeader from './ModalHeader'
import SelectedTemplatesView from './SelectedTemplatesView'
import TemplateGroupForm from './TemplateGroupForm'
import useGroupForm from './useGroupForm'

const propTypes = {
  /**
   * Callback called when cancel button is clicked
   */
  onHide: PropTypes.func.isRequired,
  /**
   * Callback called when action has succeeded
   */
  onSuccess: PropTypes.func.isRequired,
  /**
   * Array with the templates
   */
  policyTemplates: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  /**
   * map of form options that are non tenant specific
   */
  globalFormOptionsMap: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Indicates if policy template group api is being processed
   */
  loadingPolicyTemplateGroup: PropTypes.bool,
  /**
   * Indicates error in policy template group api operation
   */
  errorPolicyTemplateGroup: PropTypes.bool,
  /**
   * Create policy template group api
   */
  createPolicyTemplateGroup: PropTypes.func.isRequired,
  /**
   * Fetch policy template group api
   */
  fetchPolicyTemplateGroupList: PropTypes.func.isRequired,
  /**
   * Callback to update in parent component if the form is dirty
   */
  setHasFormChanged: PropTypes.func.isRequired,
}

function TemplateGroupCreate(props) {
  const {
    onHide,
    onSuccess,
    policyTemplates = [],
    globalFormOptionsMap = {},
    loadingPolicyTemplateGroup = false,
    errorPolicyTemplateGroup = null,
    createPolicyTemplateGroup,
    fetchPolicyTemplateGroupList,
    setHasFormChanged,
  } = props ?? {}

  const { formValues, updateForm, formOptions, toApiPayload, isFormValid, selectedTemplates, isFormDirty } =
    useGroupForm({
      policyTemplates,
    })

  useEffect(() => setHasFormChanged(isFormDirty), [isFormDirty, setHasFormChanged])

  return (
    <>
      <ModalHeader title={<FormattedMessage id="POLICY_GROUP.NEW_BASELINE" />} error={errorPolicyTemplateGroup} />

      <ModalBody>
        <TemplateGroupForm
          formValues={formValues}
          updateForm={updateForm}
          formOptions={formOptions}
          disabled={loadingPolicyTemplateGroup}
        />

        <SelectedTemplatesView selectedTemplates={selectedTemplates} globalFormOptionsMap={globalFormOptionsMap} />
      </ModalBody>

      <ModalFooter
        onHide={onHide}
        closeButtonLabel="GENERAL.CANCEL"
        loading={loadingPolicyTemplateGroup}
        primaryButtonLabel="POLICY_GROUP.CREATE_BASELINE"
        isPrimaryButtonDisabled={!isFormValid}
        onPrimaryButtonClick={async () => {
          const success = await createPolicyTemplateGroup({ data: toApiPayload() })
          if (success) {
            fetchPolicyTemplateGroupList({ policyType: POLICY_TEMPLATE_TYPES.CONDITIONAL_ACCESS })
            onSuccess()
          }
        }}
      />
    </>
  )
}

TemplateGroupCreate.propTypes = propTypes

export default TemplateGroupCreate
